import React, { useState } from "react";
import Icon1 from "../icons/Icon";

/**
 *  value = { value , label}
 */

function DropDownGPT0({
  disabled = false,
  label,
  items,
  value,
  onChange,
  className,
  mandatory = false,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (item) => {
    onChange(item);
    setIsOpen(false);
  };

  return (
    <div className={`relative ${className}`}>
      <div
        onClick={() => !disabled && setIsOpen(!isOpen)}
        onBlur={() => setIsOpen(false)}
        tabIndex={0} // to handle focus/blur
        className={`w-full px-3 py-1 min-h-8 border rounded-xl shadow-sm ${
          disabled
            ? " focus:outline-none focus:ring-transparent focus:border-neutral-300 focus:border-1"
            : "focus:outline-none focus:ring-blue-300 focus:border-blue-300 focus:border-2 cursor-pointer"
        } ${
          disabled
            ? "bg-neutral-100 border-neutral-300"
            : value
            ? "bg-white"
            : mandatory
            ? "border-red-400"
            : "bg-transparent  border-gray-300"
        }  sm:text-sm `}
      >
        <div className="flex flex-row justify-between items-center">
          {value !== null && <span>{value?.label}</span>}
          {value === null && <span className="text-shadow_50">{label}</span>}
          <Icon1 icon_name="down" height="15px" width="15px" fill="grey" />
        </div>
      </div>
      {isOpen && (
        <ul className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
          {items.map((item) => (
            <li
              key={item.value}
              className={`cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-gray-100 ${
                value && value?.value === item.value
                  ? "text-black bg-blue-100"
                  : "text-gray-900"
              }`}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSelect(item)}
            >
              <div className="flex items-center">
                <span
                  className={` block truncate  ${
                    value && value?.value === item.value ? "font-regular" : ""
                  }`}
                >
                  {item.label}
                </span>
              </div>
              {value !== null && value?.value === item.value ? (
                <span className="absolute inset-y-0 right-0 flex items-center pr-4">
                  <svg
                    className="h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default DropDownGPT0;
